import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { API } from '@app/shared/api/api.service';
import * as reset from '../state';
import { Observable } from 'rxjs';

@Injectable()
export class ResetService {
  constructor(private http: HttpClient, private api: API) {}

  public resetPassword$(body: reset.ResetPassword): Observable<string> {
    return this.http.post(this.api.PASSWORD_RESET(), body, { responseType: 'text' });
  }
}
